import cn from 'classnames'
import React, { useCallback } from 'react'

import { isMixed } from 'components/uiKit/KitUtils'
import { testPropsEl } from 'utils/test/qaData'

import type { IKitControlProps, ILabelProps, IOption } from '../KitTypes'
import * as s from './Radio.module.scss'
import RadioItem from './RadioItem/RadioItem'

export type RadioValueType = number | string | string[] | boolean | undefined

export interface IRadioProps<T extends RadioValueType> extends IKitControlProps<T> {
  options?: IOption<T>[]
  hideRadio?: boolean
  children?: React.ReactNode | string | null
  direction?: 'vertical' | 'horizontal'
  resettable?: boolean
  fluid?: boolean
  /** DON`T USE IT!!! JUST DESIgN SYNC */
  gap?: number
  justify?: 'flex-start' | 'flex-end' | 'center' | 'space-between' | 'space-around' | 'space-evenly'
}

const Radio = <T extends RadioValueType>({
  name,
  onChange,
  defaultValue,
  value = defaultValue,
  options = [],
  direction = 'vertical',
  justify = 'space-between',
  hideRadio,
  disabled,
  resettable,
  gap,
  fluid = true,
}: IRadioProps<T>) => {
  const safeValue = isMixed(value) ? undefined : (value as T)
  const handleOnChange = useCallback(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (val: any) => onChange?.(resettable && val === safeValue ? undefined : val),
    [onChange, safeValue, resettable],
  )
  return (
    <div
      {...testPropsEl('radio', { name })}
      className={cn(s.root, fluid && s.fluid, s[direction])}
      style={{ gap, justifyContent: justify }}
    >
      {options.map((item) => (
        <RadioItem
          direction={direction}
          disabled={disabled}
          hideRadio={hideRadio}
          item={item as IOption<string | number | boolean | string[], ILabelProps>}
          key={String(item.value)}
          name={name}
          onChange={handleOnChange}
          value={safeValue}
        />
      ))}
    </div>
  )
}

export default React.memo(Radio) as typeof Radio
